import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import SafetyNote from "@/components/SafetyNote";
import RichText from "@/components/RichText";
import { Reveal, PrimaryButton } from "@/components/primitives";
import Snippet from "@/components/Snippet";
import { useSite } from "@/context/SiteContext";
import { LIB } from "@/data/content";

export default function WhatToExpect() {
  const { page, img } = useSite();
  const p = page("what_to_expect");

  return (
    <div>
      <PageHero {...p.hero} image={img("what_to_expect_hero", LIB.lavenderField)} imageAlt="A calm lavender field in soft light" />

      <section className="py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal><RichText html={p.body_html} /></Reveal>
        </div>
      </section>

      <section className="relative h-[36vh] md:h-[44vh] overflow-hidden">
        <img src={img("what_to_expect_band", LIB.forestCanopy)} alt="Soft sunlight filtering through a woodland canopy" className="h-full w-full object-cover object-center" />
        <div className="absolute inset-0 bg-brand-forest-dark/25" />
      </section>

      <section className="pb-20 md:pb-28 pt-20 md:pt-28">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <Reveal><SafetyNote /></Reveal>
          <div className="mt-12 text-center">
            <PrimaryButton as={Link} to="/book" data-testid="expect-book-btn">
              <Snippet k="what_to_expect.cta" fallback="Book your session" /> <ArrowRight size={18} strokeWidth={1.5} />
            </PrimaryButton>
          </div>
        </div>
      </section>
    </div>
  );
}
